import { NODE_TYPES } from '@services/conditionEngine/constants';
import evaluatorRegistry from '@services/conditionEngine/evaluators/registry';

function constantEvaluator(node) {
  return node.value;
}

evaluatorRegistry.registerEvaluatorForNodeType(NODE_TYPES.CONSTANT, constantEvaluator);
export default constantEvaluator;
